import { render } from "./customerLessonReport.vue?vue&type=template&id=5432f7ac&ts=true"
import script from "./customerLessonReport.vue?vue&type=script&lang=ts"
export * from "./customerLessonReport.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__